import { useCallback } from 'react';
import { useAppDispatch } from 'hooks';
import { showIntegrityBlock } from 'reducers/colluderRestrictions';
import { INTEGRITY_RESTRICTION_CODE } from 'types/colluder';

// EN-10064 — client-side colluder hard-block at lobby tile-tap time.
//
// The advisory marker tells the player a table/event is restricted; this guard
// makes the TAP itself enforce it by opening the same integrity modal the
// engine's seat-commit / registration gate raises. The server gate stays the
// authoritative fallback for anyone who bypasses the tile (deep link, an
// already-open subscription, a stale client) — UI_UX_DESIGN §6.5.

/**
 * Returns a stable callback that opens the integrity hard-block modal for a
 * restricted lobby id (cash gameId or tournamentId). `scope` picks the modal
 * title ('cash' → table, 'tournament' → tournament). No waitlist recovery is
 * offered — restricted waiters are held server-side.
 */
export const useIntegrityBlockGuard = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (id: string | number, scope: 'cash' | 'tournament' = 'cash') => {
      dispatch(
        showIntegrityBlock({
          restricted: true,
          code: INTEGRITY_RESTRICTION_CODE,
          gameId: id,
          scope
        })
      );
    },
    [dispatch]
  );
};
